import $ from 'jquery'

export const renderTab = (
  $widget = $('.tabs-widget'),
  complete,
) => {
  $widget.each(function (){
    const $self =  $(this)
    const $tabClass = $self.find('.tabs-nav a')

    $tabClass.click(function (e) {
      e.preventDefault()
      const tabId = $(this).attr('data-tab')

      $tabClass.removeClass('active')
      $self.find('.tabs-widget__items--content').removeClass('active')

      $(this).addClass('active')
      $self.find(`#${tabId}`).addClass('active')
      if (typeof complete === 'function') {
        complete()
      }
    })
  })
}
